import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  apiBase = 'https://visitocare.com/doctor/api';
  constructor(private http: HttpClient) {}
  login(email: string, password: string): Observable<any> {
    return this.http.post(`${this.apiBase}/auth/login.php`, { email, password }, { withCredentials: true }).pipe(
      tap((res: any) => { if (res?.user) localStorage.setItem('user', JSON.stringify(res.user)); })
    );
  }
  signup(payload: any): Observable<any> {
    return this.http.post(`${this.apiBase}/auth/signup.php`, payload, { withCredentials: true });
  }
  verify(token: string): Observable<any> {
    return this.http.get(`${this.apiBase}/auth/verify.php?token=${encodeURIComponent(token)}`, { withCredentials: true });
  }
  me(): any {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  }
  logout(): void { localStorage.removeItem('user'); }
  isLoggedIn(): boolean { return !!this.me(); }
  forgotPassword(email: string) {
      return this.http.post(`${this.apiBase}/auth/forgot-password.php`, { email }, { withCredentials: true });
    }

  resetPassword(token: string, password: string) {
    return this.http.post(`${this.apiBase}/auth/reset-password.php`, { token, password }, { withCredentials: true });
  }
}
